import { AppBar as MuiAppBar, Stack, styled, Toolbar } from '@mui/material';
import React from 'react';
import { isSmallScreen } from 'utils';

import { SIDEBAR_WIDTH } from 'config';

import HeaderTitle from '../components/HeaderTitle';
import BackButton from '../components/BackButton';
import TopBarNavigationMenu from '../components/TopBarNavigationMenu';
import MarketerInformation from '../components/MarketerInformation';
import { AppBarProps, HeaderProps } from './types';
import { iconMapKeys } from '.icons';
const AppBar = styled(MuiAppBar, {
  shouldForwardProp: prop => prop !== 'open'
})<AppBarProps>(({ theme, open }) => ({
  zIndex: theme.zIndex.drawer + 1,
  marginLeft: !isSmallScreen() ? theme.spacing(7) : 0,
  width: `calc(100% - ${theme.spacing(7)})`,
  background: 'transparent',
  transition: theme.transitions.create(['width', 'margin'], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen
  }),
  ...(open && {
    marginLeft: !isSmallScreen() ? SIDEBAR_WIDTH : 0,
    width: !isSmallScreen() ? `calc(100% - ${SIDEBAR_WIDTH}px)` : '100%',
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen
    })
  })
}));

const MENU_OPTIONS: Array<{ label: string; href: string; icon: iconMapKeys }> = [
  {
    label: 'Plans',
    icon: 'export-2-linear',
    href: '/plan'
  },
  {
    label: 'Billing',
    icon: 'bill-linear',
    href: '/billing'
  }
];

const Header = ({ isOpen, handleLogout }: HeaderProps) => {
  return (
    <AppBar
      position="absolute"
      open={isOpen}
      sx={{
        // borderBottom: '1px solid rgba(182, 182, 182, 0.30)',
        boxShadow: 'none',
        zIndex: theme => theme.zIndex.drawer - 1
      }}
    >
      <Toolbar
        variant="dense"
        sx={{
          pr: '24px'
        }}
      >
        <BackButton />

        <HeaderTitle />

        <Stack direction="row" gap={1.5} alignItems="center">
          <TopBarNavigationMenu />

          <MarketerInformation handleLogout={handleLogout} />

          {/* <Box>
            <IconButton>
              <Badge color="primary" variant="dot">
                <Icon size="20px" name="notification-bing" />
              </Badge>
            </IconButton>
          </Box> */}
        </Stack>
      </Toolbar>
    </AppBar>
  );
};

export default Header;
